module.exports = __webpack_public_path__ + "img/f_logo.c31b7a4.png";